module.exports = __webpack_public_path__ + "img/news11.c02d076a.png";